/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plan_Student_BadgeInputs */

const en_pricing_plan_student_badge = /** @type {(inputs: Pricing_Plan_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requires university email`)
};

const de_pricing_plan_student_badge = /** @type {(inputs: Pricing_Plan_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfordert Universitäts-E-Mail`)
};

const fr_pricing_plan_student_badge = /** @type {(inputs: Pricing_Plan_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nécessite un e-mail universitaire`)
};

const es_pricing_plan_student_badge = /** @type {(inputs: Pricing_Plan_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requiere correo universitario`)
};

const it_pricing_plan_student_badge = /** @type {(inputs: Pricing_Plan_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiede email universitaria`)
};

const nl_pricing_plan_student_badge = /** @type {(inputs: Pricing_Plan_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereist universiteits-e-mailadres`)
};

const pl_pricing_plan_student_badge = /** @type {(inputs: Pricing_Plan_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wymaga adresu e-mail uczelni`)
};

const fi_pricing_plan_student_badge = /** @type {(inputs: Pricing_Plan_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaatii yliopiston sähköpostin`)
};

const da_pricing_plan_student_badge = /** @type {(inputs: Pricing_Plan_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kræver universitetsmail`)
};

const sv_pricing_plan_student_badge = /** @type {(inputs: Pricing_Plan_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kräver universitetsmejl`)
};

/**
* | output |
* | --- |
* | "Requires university email" |
*
* @param {Pricing_Plan_Student_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_plan_student_badge = /** @type {((inputs?: Pricing_Plan_Student_BadgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plan_Student_BadgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_plan_student_badge(inputs)
	if (locale === "fr") return fr_pricing_plan_student_badge(inputs)
	if (locale === "es") return es_pricing_plan_student_badge(inputs)
	if (locale === "it") return it_pricing_plan_student_badge(inputs)
	if (locale === "nl") return nl_pricing_plan_student_badge(inputs)
	if (locale === "pl") return pl_pricing_plan_student_badge(inputs)
	if (locale === "fi") return fi_pricing_plan_student_badge(inputs)
	if (locale === "da") return da_pricing_plan_student_badge(inputs)
	if (locale === "sv") return sv_pricing_plan_student_badge(inputs)
	return en_pricing_plan_student_badge(inputs)
});